const UsersMultipleIcon = ({ className, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.08249 2.08301C4.8259 2.08301 2.99658 3.90311 2.99658 6.14832C2.99658 8.39354 4.8259 10.2136 7.08249 10.2136C9.33908 10.2136 11.1684 8.39354 11.1684 6.14832C11.1684 3.90311 9.33908 2.08301 7.08249 2.08301Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M13.0335 13.8214C12.5236 13.3427 11.7784 12.9397 11.3033 12.6827C11.1975 12.6256 11.1051 12.5756 11.0317 12.5337C8.61319 11.152 5.55217 11.152 3.13364 12.5337C3.06022 12.5756 2.96782 12.6256 2.86204 12.6828C2.38694 12.9397 1.64172 13.3427 1.1319 13.8214C0.814458 14.1196 0.486085 14.5357 0.425798 15.0648C0.360564 15.6374 0.625583 16.1544 1.10168 16.5895C1.90082 17.32 2.8725 17.9163 4.13281 17.9163H10.0326C11.2929 17.9163 12.2645 17.32 13.0637 16.5895C13.5398 16.1544 13.8048 15.6374 13.7396 15.0648C13.6793 14.5357 13.3509 14.1196 13.0335 13.8214Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M11.2561 9.59505C11.2236 9.48158 11.3093 9.36694 11.4807 9.13766C12.1245 8.27638 12.5008 7.23586 12.5008 6.11527C12.5008 5.53721 12.4007 4.98046 12.2153 4.45863C12.1215 4.19431 12.0745 4.06215 12.1408 3.96153C12.2072 3.8609 12.3328 3.84052 12.584 3.79976C12.7869 3.76685 12.9957 3.74967 13.209 3.74967C15.1645 3.74967 16.7498 5.19392 16.7498 6.97548C16.7498 8.75704 15.1645 10.2013 13.209 10.2013C12.642 10.2013 12.1062 10.0799 11.6311 9.86408C11.4028 9.76037 11.2886 9.70852 11.2561 9.59505Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M18.8387 15.966C18.013 16.5862 17.0201 17.083 15.7435 17.083C15.2939 17.083 15.0691 17.083 14.984 16.9823C14.9786 16.9758 14.9756 16.972 14.9708 16.9652C14.895 16.8585 14.9826 16.6333 15.158 16.1829C15.3052 15.8048 15.3706 15.3862 15.3141 14.9318C15.1921 13.9515 14.5451 13.2685 14.1039 12.8891C13.9078 12.7205 13.6845 12.5586 13.4536 12.4075C12.8456 12.0095 12.5416 11.8105 12.6196 11.6247C12.6976 11.439 13.039 11.4726 13.7217 11.5399C14.7804 11.6443 15.8168 11.9176 16.7589 12.3598C16.8323 12.3943 16.9252 12.4355 17.0319 12.4829C17.5154 12.6977 18.2827 13.0385 18.8086 13.4444C19.1296 13.6921 19.5016 14.0653 19.5712 14.5668C19.6486 15.1252 19.328 15.5985 18.8387 15.966Z"
        fill={fill || "#D1D5DB"}
      />
    </svg>
  );
};

export default UsersMultipleIcon;
